module.exports = __webpack_public_path__ + "img/wash_baby_5.8bfd3a03.png";